import {
  Layout as AntdLayout,
  Button,
  Card,
  Checkbox,
  Col,
  Form,
  Input,
  Row,
  Typography,
} from "antd";
import { useLogin } from "@refinedev/core";
import React from "react";
import "./styles.css";
import { useSearchParams } from "react-router-dom";

const { Text, Title } = Typography;

export interface ILoginForm {
  username: string;
  password: string;
  remember: boolean;
}

export const Login: React.FC = () => {
  const [form] = Form.useForm<ILoginForm>();
  const { mutate: login } = useLogin<ILoginForm>();

  const [searchParams] = useSearchParams();
  const redirectTo = searchParams.get("redirect") || undefined;

  const handleLogin = (values: ILoginForm) => {
    login({ ...values, redirectTo } as any);
  };

  const CardTitle = (
    <Title level={3} className="title">
      Sign in to your account
    </Title>
  );

  return (
    <AntdLayout className="layout">
      <Row
        justify="center"
        align="middle"
        style={{
          height: "100vh",
        }}
      >
        <Col xs={22}>
          <div className="container">
            <div className="imageContainer">
              <img src="/emariner-logo-pro.png" alt="eMariner Admin Logo" />
            </div>
            <Card title={CardTitle} styles={{ header: { borderBottom: 0 } }}>
              <Form<ILoginForm>
                layout="vertical"
                form={form}
                onFinish={handleLogin}
                requiredMark={false}
                initialValues={{
                  remember: true,
                }}
              >
                <Form.Item
                  name="username"
                  label="Username"
                  rules={[{ required: true }]}
                >
                  <Input size="large" placeholder="Username" />
                </Form.Item>
                <Form.Item
                  name="password"
                  label="Password"
                  rules={[{ required: true }]}
                  style={{ marginBottom: "12px" }}
                >
                  <Input type="password" placeholder="●●●●●●●●" size="large" />
                </Form.Item>
                <div style={{ marginBottom: "12px" }}>
                  <Form.Item name="remember" valuePropName="checked" noStyle>
                    <Checkbox
                      style={{
                        fontSize: "12px",
                      }}
                    >
                      Remember me
                    </Checkbox>
                  </Form.Item>

                  {
                    <a
                      style={{
                        float: "right",
                        fontSize: "12px",
                      }}
                      href={`mailto:${process.env.REACT_APP_ACCOUNT_SUPPORT_EMAIL || 'samith@emariner.net'}?subject=Password%20reset%20request`}
                    >
                      Forgot password?
                    </a>
                  }
                </div>
                <Button type="primary" size="large" htmlType="submit" block>
                  Sign in
                </Button>
              </Form>
              <div style={{ marginTop: 8 }}>
                <Text style={{ fontSize: 12 }}>
                  Don’t have an account?{" "}
                  <a
                    href={`mailto:${process.env.REACT_APP_ACCOUNT_SUPPORT_EMAIL || 'samith@emariner.net'}?subject=Account%20creation%20request`}
                    style={{ fontWeight: "bold" }}
                  >
                    Contact Admin
                  </a>
                </Text>
              </div>
            </Card>
          </div>
        </Col>
      </Row>
    </AntdLayout>
  );
};
